module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sharers.length > 0) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.sharers), function(s) {
    return _c('el-collapse-item', {
      key: s.id
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: 'fa ' + (s.status == 'Terminated' ? 'fa-user-slash text-danger' : 'fa-users text-primary')
    }), _vm._v(" "), _c('em', {
      staticClass: "text-black"
    }, [_vm._v(_vm._s(s.organisation.name))])]), _vm._v(" "), _c('finance-sharer', {
      attrs: {
        "sharer": s,
        "site-data": _vm.rowData
      }
    })], 2)
  }), 1) : _c('center', {
    staticStyle: {
      "padding-top": "0.528em"
    }
  }, [_vm._v("No sharers found.")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e1c530c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/SiteFinanceSharers.vue
// module id = 1579
// module chunks = 0